import { render, staticRenderFns } from "./flipScroll.vue?vue&type=template&id=775d54dc&"
import script from "./flipScroll.vue?vue&type=script&lang=ts&"
export * from "./flipScroll.vue?vue&type=script&lang=ts&"
import style0 from "./flipScroll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports